import { createRoot } from 'react-dom/client'

import '@/app/styles/style.scss'

import { App } from '@App/App'

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
    <div>
        <App />
    </div>
)
